export default __webpack_public_path__ + "b80d4dc4347d7d1e009ca13615fd9258.png";